import { MEMBER_NOTIFICATION_ARTICLE_LINK } from "../../../constants";

export default function ReviewAndActivate({
  activatingUsersCount,
  collectingPaymentUsersCount,
  hasSubAccounts,
}: {
  activatingUsersCount: number;
  collectingPaymentUsersCount: number;
  hasSubAccounts: boolean;
}) {
  return (
    <>
      <div className="tw-max-w-3xl tw-mx-auto tw-px-4">
        <div className="tw-rounded-3xl tw-border tw-border-gray-200 tw-p-6 tw-space-y-4">
          <div className="tw-space-y-2">
            <div className="tw-flex tw-items-baseline tw-gap-2">
              <span className="tw-font-medium tw-text-gray-900">
                Activating
              </span>
              <span className="tw-text-md tw-text-gray-500">
                {activatingUsersCount} members
              </span>
            </div>
            <p className="tw-mt-1 tw-text-sm tw-text-gray-500">
              These members will receive a{" "}
              <a
                href={MEMBER_NOTIFICATION_ARTICLE_LINK}
                target="_blank"
                rel="noreferrer"
                className="tw-text-blue-500 tw-hover:underline"
              >
                welcome email
              </a>{" "}
              with instructions to download the Members app or your branded app.
              {hasSubAccounts && " *"}
            </p>
          </div>
          <div className="tw-pt-3 tw-border-t tw-space-y-2">
            <div className="tw-flex tw-items-baseline tw-gap-2">
              <span className="tw-font-medium tw-text-gray-900">
                Collecting payment from
              </span>
              <span className="tw-text-md tw-text-gray-500">
                {collectingPaymentUsersCount} members
              </span>
            </div>
            <p className="tw-mt-1 tw-text-sm tw-text-gray-500">
              These members will be prompted to add a payment method when they
              login to the Members app or your branded app.
              {hasSubAccounts && " *"}
            </p>
          </div>
        </div>
        {hasSubAccounts && (
          <div className="tw-flex tw-items-center tw-pl-6 tw-pt-4">
            <p className="tw-text-sm tw-text-gray-500">
              * Email communication and payment collection for sub-accounts will
              be directed to the primary account.
            </p>
          </div>
        )}
      </div>
    </>
  );
}
